import { AccountWithBalance } from 'common/state/accounts/actions';
import {
  Client,
  ExternalBankAccount,
  Wallet,
} from 'common/state/banking/actions';

export interface CardState {
  accountsPending: boolean;
  accounts: AccountWithBalance[] | null;
  accountsError?: string;
  bankAccountsPending: boolean;
  bankAccounts: ExternalBankAccount[] | null;
  bankAccountsError?: string;
  clientsPending: boolean;
  clients: Client[] | null;
  clientsError?: string;
  walletsPending: boolean;
  wallets: Wallet[] | null;
  walletsError?: string;
}

export const defaultCardState: CardState = {
  accountsPending: false,
  accounts: null,
  accountsError: null,
  bankAccountsPending: false,
  bankAccounts: null,
  bankAccountsError: null,
  clientsPending: false,
  clients: null,
  clientsError: null,
  walletsPending: false,
  wallets: null,
  walletsError: null,
};
